import { render, staticRenderFns } from "./aboutGoods.vue?vue&type=template&id=4b785262&scoped=true"
import script from "./aboutGoods.vue?vue&type=script&lang=js"
export * from "./aboutGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b785262",
  null
  
)

export default component.exports